import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ list, rank }) =>
    present(
      repository
        .duplicateList(list, rank)
        .then((duplicatedList) => ({ list, duplicatedList, rank }))
        .catch((error) => Promise.reject({ list, rank })),
    );
}

export type { Interactor };

export { createInteractor };
